<div class="agent-confirmation">
  <p class="summary">{{ confirmation().summary }}</p>
  @if (shownDetails().length) {
    <dl class="details">
      @for (detail of shownDetails(); track detail.label) {
        <div>
          <dt>{{ detail.label }}</dt>
          <dd>{{ detail.value }}</dd>
        </div>
      }
    </dl>
  }
  @if (prettyPayload(); as payload) {
    <pre class="payload" style="display: none">{{ payload }}</pre>
  }

  @if (rejecting()) {
    <label class="feedback-label" [attr.for]="feedbackId">
      {{ feedbackLabel() }}
    </label>
    <textarea
      [id]="feedbackId"
      class="feedback"
      rows="3"
      [value]="feedback()"
      (input)="onFeedback($event)"></textarea>
    <forma-button-group align="start">
      <button formaButton="text" type="button" (click)="cancelReject()">
        {{ cancelLabel() }}
      </button>
      <button formaButton="primary" type="button" (click)="confirmReject()">
        {{ saveLabel() }}
      </button>
    </forma-button-group>
  } @else {
    <forma-button-group align="start">
      <button formaButton="text" type="button" (click)="rejecting.set(true)">
        {{ rejectLabel() }}
      </button>
      <button formaButton="primary" type="button" (click)="approve.emit()">
        {{ approveLabel() }}
      </button>
    </forma-button-group>
  }
</div>
